import React from "react";

// NEXIS network-node mark — crisp SVG, navy + cyan.
export function NexisMark({ size = 36, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <rect x="2" y="2" width="44" height="44" rx="11" fill="#0E2340" />
      <rect x="2" y="2" width="44" height="44" rx="11" stroke="#1E88E5" strokeOpacity="0.35" strokeWidth="1.2" />
      {/* connective links */}
      <path d="M13 34 L24 14 L35 34" stroke="#22D3EE" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M13 34 L35 34" stroke="#1E88E5" strokeWidth="2.4" strokeLinecap="round" />
      <path d="M24 14 L24 27" stroke="#5EEAD4" strokeWidth="2" strokeLinecap="round" strokeDasharray="1 3" />
      {/* nodes */}
      <circle cx="24" cy="14" r="3.4" fill="#22D3EE" />
      <circle cx="13" cy="34" r="3.4" fill="#5EEAD4" />
      <circle cx="35" cy="34" r="3.4" fill="#1E88E5" />
      <circle cx="24" cy="27" r="2.3" fill="#E2F6FB" />
    </svg>
  );
}

export function NexisLogo({ compact = false, subtitle = "Connectivity Infrastructure" }) {
  return (
    <div className="flex items-center gap-2.5" data-testid="nexis-logo">
      <NexisMark size={compact ? 30 : 38} />
      <div className="leading-none">
        <div className="flex items-baseline gap-1.5">
          <span className="font-bold tracking-[0.18em] text-white text-lg">NEXIS</span>
        </div>
        {!compact && (
          <span className="block text-[10px] uppercase tracking-[0.22em] text-cyan-300/80 mt-1">
            {subtitle}
          </span>
        )}
      </div>
    </div>
  );
}
